import React, { useEffect, useState } from "react";
import { getUserDetails } from "./userDetails";
const config = require("../assets/config.json");

function MsLogin() {
  const [loading, setLoading] = useState(false);

  async function handleLogin() {
    const urlParams = new URLSearchParams(window.location.search);
    const userData = urlParams.get("userData");

    if (userData !== undefined && userData) {
      sessionStorage.setItem("8ee22acb-94b0-481d-b11b-f87168b880e3", userData);
      const userDetails = await getUserDetails();
      setLoading(true);

      userDetails?.Department === "Finance" ||
      userDetails?.Department === "HR" ||
      userDetails?.Department === "HRD" ||
      userDetails?.Department === "Administration" ||
      userDetails?.Department === "Management"
        ? (window.location.href = `${config.REACT_APP_URL}/dashboard`)
        : (window.location.href = `${config.REACT_APP_URL}/my-tickets`);

      setLoading(false);
    } else {
      window.location.href =
        config.REACT_APP_LOGINGATEWAY +
        `/login` +
        `?redirectURL=${config.REACT_APP_REDIRECT_URL}`;
    }
    setLoading(false);
  }

  useEffect(() => {
    handleLogin();
  }, []); // ✅ No need to add handleLogin to dependency list

  return (
    <div>
      {!loading ? (
        <div className="signout-container">
          <div className="Signout-div">
            <div className="w-70">
              <h1 className="signout-header">Redirecting...</h1>
            </div>
          </div>
        </div>
      ) : null}
      {/* {loading && <SpinnerComponent />} */}
      {loading && "LOADING..."}
    </div>
  );
}

export default MsLogin;
